<template id="view">
  <div id="articlea" class="container">
    <section>
      <div class="row">
        <div class="col-lg-12 pr-lg-4">
          <!-- 文章內容 -->

          <div class="article-view section-group">
            <div class="card p-3 p-sm-4 p-md-5">
              <div class="content mb-4 ql-editor" v-html="pageContent"></div>
            </div>
          </div>
          <!-- ./文章內容 -->
        </div>
      </div>
    </section>
  </div>
</template>


<script>
import "../../../node_modules/vue-social-sharing/dist/vue-social-sharing.js";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

export default {
  data() {
    return {
      pageContent: "",
      pageTitle: "",
    };
  },
  components: {},
  watch: {
    pageTitle: {
      handler: function (newval, oldval) {
        document.title = newval + " - 尋寶網";
      },
    },
  },
  created() {
    this.getPageInfo();
  },
  methods: {
    getPageInfo() {
      this.$api.permissionApi
        .getFootDetailInfo({
          url: this.$route.params.key,
        })
        .then((res) => {
          this.pageContent = res.data.result.sgL_Content;
          this.pageTitle = res.data.result.title;
        });
    },
    getHtmlContent(str) {
      str = str.replace(/&lt;/g, "<");
      str = str.replace(/&gt;/g, ">");
      return str;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/initFoot.vue